import React, { ButtonHTMLAttributes } from 'react';
import { ButtonWrapper } from './Button.style';
import classnames from 'classnames';

type ButtonTheme = 'fill' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme: ButtonTheme;
  children: React.ReactNode;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  theme,
  disabled,
  children,
  fullWidth = false,
  ...restProps
}) => {
  return (
    <ButtonWrapper
      className={classnames(theme, { disabled, fullWidth })}
      {...restProps}
    >
      {children}
    </ButtonWrapper>
  );
};
